<template>
  <LayoutDefault>
    <template v-slot:no-padding>
      <Challenge :challenge="challenge" />
    </template>
  </LayoutDefault>
</template>
<script>
import Challenge from "../components/Challenge";
import LayoutDefault from "../layouts/LayoutDefault";
export default {
  name: "ChallengeView",
  components: {
    LayoutDefault,
    Challenge
  },
  data() {
    return { isLastChallenge: true };
  },
  computed: {
    challenge: function() {
      if (this.isLastChallenge) {
        return this.$store.state.lastChallenge;
      } else {
        return this.$store.state.selectedChallenge;
      }
    }
  },
  mounted() {
    if (this.$route.params.challengeId) {
      this.isLastChallenge = false;
    } else {
      this.isLastChallenge = true;
    }
  }
};
</script>
